import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'

export const AuthLayout = () => {
  useEffect(() => {
    if (
      process.env.REACT_APP_PROJECT === 'bluepear' &&
      process.env.REACT_APP_BUILD_ENV === 'prod'
    ) {
      const gtagScript = document.createElement('script')
      gtagScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "granted",
          wait_for_update: 2000,
        });
        gtag("set", "ads_data_redaction", true);
        gtag("set", "url_passthrough", true);
      `
      document.head.appendChild(gtagScript)

      const gtmScript = document.createElement('script')
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-NKXFCZD');
      `
      document.head.appendChild(gtmScript)

      return () => {
        document.head.removeChild(gtagScript)
        document.head.removeChild(gtmScript)
      }
    }

    if (
      process.env.REACT_APP_PROJECT === 'robuscan' &&
      process.env.REACT_APP_BUILD_ENV === 'prod-robuscan-ru'
    ) {
      const gtmScript = document.createElement('script')
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PJ4D9G86');
      `
      document.head.appendChild(gtmScript)

      return () => {
        document.head.removeChild(gtmScript)
      }
    }
  }, [])

  return <Outlet />
}
